import { useEffect } from "react";
// my imports:
import { GameManager } from "@/app/lib/game-state/game-manager";
import UI from "@/app/lib/ui/ui";

export function useVictoryCheck(gameManager: GameManager, ui: UI) {
    useEffect(() => {
        if (gameManager.active.state.completed) {
            console.log("Completed!");
            setTimeout(() => {
                ui.defocusAll();
            }, 0);
        }
        if (gameManager.active.state.victorious) {
            console.log("Victorious!")
            // increment the streak here if we are victorious
            if (gameManager.activeMode === 'pyramid') {
                ui.incrementStreak();
                ui.logPyramidVictory(); // save lifetime total wins in local storage
            }
            // show a nice victory animation
            ui.wordBoxAnimations.accept.forEach((a) => {
                a();
            });
        }
    }, [
        gameManager.active.state.completed,
        gameManager.active.state.victorious
    ])
}